import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import {
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_SortingState,
} from "mantine-react-table";

export interface AuditDataResponse {
  data: AuditData[];
  meta: {
    totalRowCount: number;
  };
}

export interface AuditData {
  id: number;
  userId: number;
  name: string;
  email: string;
  role: string;
  action: string;
  method: string;
  description: string;
  metadata: any;
  url: string;
  createdAt: string;
  createdAtFormatted: string;
}

interface AuditDataRequest {
  token: string;
  pagination: MRT_PaginationState;
  columnFilters: MRT_ColumnFiltersState;
  sorting: MRT_SortingState;
}

const getAuditData = async ({
  token,
  pagination,
  columnFilters,
  sorting,
}: AuditDataRequest): Promise<AuditDataResponse> => {
  try {
    const response = await axios.get(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/get-audit-data`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: {
          page: `${pagination.pageIndex + 1}`,
          pageSize: `${pagination.pageSize}`,
          columnFilters: columnFilters,
          sorting: sorting,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);

    throw new Error(message);
  }
};

export default getAuditData;
